




























































































import Vue from 'vue';
import customerClient from '../../../../customer/apis';
import Customer from '../../../../customer/models/Customer';
import commonVuex from '../../../../common/vuex/common';

const suggestCustomers: Customer[] = [];
const suggestTimeout: any = null;
const searchKeyword: string | null = null;

export default Vue.extend({
  mixins: [commonVuex],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showBox: false,
      showSuggest: false,
      searchKeyword,
      suggestCursor: -1,
      historyRecords: [],
      suggestCustomers,
      suggestTimeout,
      hackId: 0,
    };
  },
  computed: {
    historyCustomers(): string[] {
      const rds = JSON.parse(JSON.stringify(this.historyRecords));
      return rds.reverse();
    },
    historyKey(): string {
      return `customerPreview${this.account.weixinId}`.replace('_', '');
    },
  },
  methods: {
    suggest() {
      clearTimeout(this.suggestTimeout);
      this.suggestTimeout = setTimeout(() => {
        customerClient.suggest({
          page: 1,
          key: this.searchKeyword,
        }).success((r) => {
          this.suggestCustomers = r.customers.map((c: Customer) => {
            return new Customer(c);
          });
        });
      }, 300);
    },
    location(customer: Customer): string {
      if (customer.wxProps.country !== '中国') {
        return customer.wxProps.country;
      } else {
        return [
          customer.wxProps.province,
          customer.wxProps.city,
        ].filter((s) => {
          return s && s.trim() !== '';
        }).join(',');
      }
    },
    hitTelephone(customer: Customer): boolean {
      if (!customer.phone) {
        return false;
      } else {
        return customer.phone.indexOf(this.searchKeyword) !== -1;
      }
    },
    hitRealname(customer: Customer): boolean {
      if (!customer.realName) {
        return false;
      } else {
        return customer.realName.indexOf(this.searchKeyword) !== -1;
      }
    },
    nextSuggest() {
      if (this.suggestCursor < this.suggestCustomers.length - 1) {
        this.suggestCursor++;
      }
    },
    prevSuggest() {
      if (this.suggestCursor > 0) {
        this.suggestCursor--;
      } else {
        this.suggestCursor = -1;
      }
    },
    onSearch() {
      if (this.suggestCursor !== -1) {
        this.selectPreviewer(this.suggestCustomers[this.suggestCursor], true);
      }
    },
    selectPreviewer(customer: Customer, afterSearch: boolean) {
      if (afterSearch) {
        this.setHistoryPreviewer(customer);
      }
      this.setHistorySelectedPreviewer(customer);
      this.selectedCustomer = customer;
      this.showSuggest = false;
      this.searchKeyword = null;
      this.hackId++;
    },
    setHistorySelectedPreviewer(previewer: Customer) {
    },
    setHistoryPreviewer(previewer: Customer) {
      const index = this.historyRecords.findIndex( r => r.openid === previewer.openid);
      if (index !== -1) {
        this.historyRecords.splice(index, 1);
      }
      this.historyRecords.push(previewer);
      if (this.historyRecords.length > 10) {
        this.historyRecords.splice(0, this.historyRecords.length - 10);
      }
      Vue.localStorage.set(this.historyKey, JSON.stringify(this.historyRecords));
    },
  },
  mounted() {
    this.showBox = this.show;
    this.historyRecords = JSON.parse(Vue.localStorage.get(this.historyKey, '[]'));
  },
  watch: {
    show() {
      this.showBox = this.show;
    },
  },
});
